import { render, staticRenderFns } from "./WebSourceManagementOverview.vue?vue&type=template&id=f4286590&scoped=true&"
import script from "./WebSourceManagementOverview.vue?vue&type=script&lang=js&"
export * from "./WebSourceManagementOverview.vue?vue&type=script&lang=js&"
import style0 from "./WebSourceManagementOverview.vue?vue&type=style&index=0&id=f4286590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4286590",
  null
  
)

/* custom blocks */
import block0 from "./WebSourceManagementOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4286590')) {
      api.createRecord('f4286590', component.options)
    } else {
      api.reload('f4286590', component.options)
    }
    module.hot.accept("./WebSourceManagementOverview.vue?vue&type=template&id=f4286590&scoped=true&", function () {
      api.rerender('f4286590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/web-source-management/WebSourceManagementOverview.vue"
export default component.exports